import { createContext, ReactNode, useEffect } from 'react';
import { ThemeType } from './Types/theme';
import { useMySettingsProvider } from './Hooks/useMySettingsProvider';
import { MySettingsContextProps } from './Types/mySettings';

type Props = {
  children: ReactNode;
}

export const MySettingsContext = createContext<MySettingsContextProps>({
  theme: {
    set: () => { },
    current: ThemeType.Light,
  }
});

export const MySettingsProvider = ({ children }: Props) => {
  const mySettings = useMySettingsProvider();

  useEffect(() => {
    const currentTheme = `theme-${mySettings.theme.current}`;
    const body = document.getElementsByTagName("body")?.[0];
    if (body) {
      const oldTheme = body.className.match(/theme-\w+Mode/gi)?.[0];
      if (oldTheme) {
        body.classList.replace(oldTheme, currentTheme);
      } else {
        body.classList.add(currentTheme);
      }
    }
  }, [mySettings.theme]);

  return (
    <MySettingsContext.Provider value={mySettings}>
      <div className={`theme-${mySettings.theme.current}`}>{children}</div>
    </MySettingsContext.Provider>
  );
}
